import { hbs } from 'ember-cli-htmlbars';
export default hbs("<SiteWrapper::Breadcrumb\n  @label={{t \'KPI Compare Report\'}}\n  @route=\'routes/reports.kpi-compare.index\'\n/>\n\n{{outlet}}")